export default {
  game: "Trucks'n'Tricks",
  title: "Welcome Back",
  description: "Do you want to continue the game from where you left off?",
  no: "No, start a new game",
  yes: "Yes, continue from where I left off"
};
